import { render, staticRenderFns } from "./FeeAttorneyStats.vue?vue&type=template&id=33f2ebb6&scoped=true&"
import script from "./FeeAttorneyStats.vue?vue&type=script&lang=js&"
export * from "./FeeAttorneyStats.vue?vue&type=script&lang=js&"
import style0 from "./FeeAttorneyStats.vue?vue&type=style&index=0&id=33f2ebb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2ebb6",
  null
  
)

export default component.exports